import React, { useState } from "react";
import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Divider,
  Box,
  alpha,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CheckIcon from "@mui/icons-material/Check";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

// 1. 优化菜单纸张的样式：增加圆角、阴影和微边框
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    transformOrigin={{ vertical: "top", horizontal: "right" }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 12,
    minWidth: 240,
    marginTop: theme.spacing(1),
    boxShadow: "0 12px 40px -8px rgba(0, 0, 0, 0.12)",
    border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
    "& .MuiMenuItem-root": {
      padding: "10px 16px",
      "&:hover .delete-btn": {
        // 鼠标悬停时才显示删除按钮
        opacity: 1,
      },
    },
  },
}));

const SavedViewsMenu = ({
  saveViewAnchor,
  setSaveViewAnchor,
  savedViews = [],
  currentViewName, // 当前正在使用的视图名称，用于高亮
  applySavedView,
  deleteSavedView, // 新增：删除视图的回调
}) => {
  const handleClose = () => setSaveViewAnchor(null);

  return (
    <StyledMenu
      anchorEl={saveViewAnchor}
      open={Boolean(saveViewAnchor)}
      onClose={handleClose}
    >
      {/* 2. 空状态优化 */}
      {savedViews.length === 0 ? (
        <Box
          sx={{ px: 2, py: 3, textAlign: "center", color: "text.secondary" }}
        >
          <VisibilityIcon sx={{ fontSize: 40, opacity: 0.3, mb: 1 }} />
          <Typography variant='body2'>No saved filters</Typography>
        </Box>
      ) : (
        <>
          {savedViews.map((v) => {
            const isActive = v.name === currentViewName;
            return (
              <MenuItem
                key={v.name}
                onClick={() => {
                  applySavedView(v);
                  handleClose();
                }}
                sx={{
                  bgcolor: isActive ? alpha("#1976d2", 0.08) : "transparent", // 选中项带一点背景色
                  color: isActive ? "primary.main" : "inherit",
                }}
              >
                <ListItemIcon>
                  {isActive ? (
                    <CheckIcon fontSize='small' color='primary' />
                  ) : (
                    <VisibilityIcon fontSize='small' />
                  )}
                </ListItemIcon>
                <ListItemText primary={v.name} />

                {/* 3. 悬停显示的删除按钮 */}
                <IconButton
                  size='small'
                  className='delete-btn'
                  onClick={(e) => {
                    e.stopPropagation(); // 阻止触发菜单项的点击事件
                    deleteSavedView(v.name);
                  }}
                  sx={{
                    ml: 1,
                    opacity: 0, // 默认隐藏
                    transition: "opacity 0.2s",
                    color: "text.secondary",
                    "&:hover": {
                      color: "error.main",
                      bgcolor: alpha("#f44336", 0.1),
                    },
                  }}
                >
                  <DeleteOutlineIcon fontSize='small' />
                </IconButton>
              </MenuItem>
            );
          })}
          {savedViews.length > 1 && <Divider sx={{ my: 0.5 }} />}
        </>
      )}
    </StyledMenu>
  );
};

export default SavedViewsMenu;
